<template>
	<div class="notifications-wrapper">
		<notification-item v-for="item in notifications" :notification="item" :key="item.uuid"></notification-item>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'
import { STATE_MODULES } from '@/store/state-modules';
import NotificationItem from './NotificationItem.vue';
import { ConfigGetters } from '@/store/modules/config/getters';

export default defineComponent({
	computed: {
		...mapGetters(STATE_MODULES.CONFIG, {
			notifications: ConfigGetters.NOTIFICATION_LIST
		})
	}, 
	components: {
		NotificationItem
	}
})
</script>

<style scoped>
	.notifications-wrapper {
		position: fixed;
		width: 100%;
		bottom: 0;
		left: 0;
		padding: 10px;
	}
</style>
